import { SelectMenu } from './select-menu'
import { SelectMenuDrawerProps } from './select-menu.types'
import { nothing } from '$func/utils'
import {
  BottomDrawer,
  DRAWER_MAX_HEIGHT_PERCENTAGE,
  PULLER_HEIGHT,
} from '$common/bottom-drawer'

export function SelectMenuDrawer({
  isOpen = false,
  headerTexts = [],
  getHeaderText = (depth: number, selectedOptions: string[]) =>
    selectedOptions[depth - 1],
  HeaderIcon,
  optionFetchers,
  alignOptionsCenter = false,
  onDone,
  sx,
  onClose = nothing,
}: SelectMenuDrawerProps) {
  const selectMenuMaxHeight =
    Math.ceil(window.innerHeight * (DRAWER_MAX_HEIGHT_PERCENTAGE / 100)) -
    PULLER_HEIGHT

  return (
    <BottomDrawer sx={sx} onClose={onClose} isOpen={isOpen}>
      <SelectMenu
        headerTexts={headerTexts}
        getHeaderText={getHeaderText}
        HeaderIcon={HeaderIcon}
        optionFetchers={optionFetchers}
        alignOptionsCenter={alignOptionsCenter}
        maxHeight={selectMenuMaxHeight}
        onDone={onDone}
      />
    </BottomDrawer>
  )
}
